var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fab-transition')
}
var staticRenderFns = []

export { render, staticRenderFns }